(() => {

    angular
        .module('smartertoolsApp')
        .controller('cartAddProductController',
            ['$scope', '$location', 'authenticationService', '$routeParams', '$http', cartAddProductController]);

    function cartAddProductController($scope, $location, authenticationService, $routeParams, $http) {
        const vm = this;
        vm.isReseller = authenticationService.isReseller();
        vm.hasHighAvailability = authenticationService.hasHighAvailability();


        // Functions
        vm.addProductTotal = addProductTotal;
        vm.canOfferInstallation = canOfferInstallation;
        vm.addProductIncrementAlaCarte = addProductIncrementAlaCarte;
        vm.addProductDecrementAlaCarte = addProductDecrementAlaCarte;
        vm.addProductQueryOptions = addProductQueryOptions;
        vm.addProductUpdateOption = addProductUpdateOption;
        vm.addProductToCart = addProductToCart;
        vm.getCartContents = getCartContents;
        vm.toggleSupportOption = toggleSupportOption;
        vm.switchToSection = switchToSection;
        vm.addInstallationOffer = addInstallationOffer;
        vm.clickedHighAvailability = clickedHighAvailability;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.addProduct = {
                selections: {Product: $routeParams.product},
                state: null,
                productCounts: {},
                alaCarteCost: 0
            };
            vm.cartGuid = SessionStorageWithFallback.get('smartertoolsCartGuid');
            SessionStorageWithFallback.set('RemovalItemId', '');
            SessionStorageWithFallback.set('smartertoolsPreCart', '');
            autoSpinner = true;
            vm.addProductQueryOptions();
            vm.getCartContents();
            getBack();

            $scope.$on('authentication:logged-in', onLoggedIn);
            $scope.$on('authentication:logged-out', onLoggedOut);
        }

        function onLoggedIn() {
            vm.isReseller = authenticationService.isReseller();
            vm.hasHighAvailability = authenticationService.hasHighAvailability();
        }

        function onLoggedOut() {
            vm.isReseller = authenticationService.isReseller();
            vm.hasHighAvailability = authenticationService.hasHighAvailability();
        }

        function switchToSection(section) {
            if (section === 'Edition') {
                activate();
                return false;
            }
            vm.addProduct.state.CurrentSection = section;
        }

        function clickedHighAvailability() {
            if (vm.hasHighAvailability) {
                location.href = '/account#high-availability';
            } else {
                // Do nothing
            }
        }

        function canOfferInstallation() {
            if (vm.isReseller) {
                return vm.isReseller;
            }
            return (vm.addProduct.state ? vm.addProduct.state.Product === 'support' : true);
        }

        function addProductTotal() {
            return (vm.addProduct.state ? vm.addProduct.state.Total + 0 : 0) + vm.addProduct.alaCarteCost;
        }

        function addProductIncrementAlaCarte(e, id, cost) {
            if (!vm.addProduct.productCounts[`${id}`])
                vm.addProduct.productCounts[`${id}`] = 1;
            else
                vm.addProduct.productCounts[`${id}`] = vm.addProduct.productCounts[`${id}`] + 1;
            vm.addProduct.alaCarteCost += cost;

            e.preventDefault();
        }

        function addProductDecrementAlaCarte(e, title, id, cost) {
            if (!vm.addProduct.productCounts[`${id}`] || vm.addProduct.productCounts[`${id}`] < 1) {
                vm.addProduct.productCounts[`${id}`] = 0;
            } else {
                vm.addProduct.productCounts[`${id}`] = vm.addProduct.productCounts[`${id}`] - 1;
                vm.addProduct.alaCarteCost -= cost;
            }

            if (vm.addProduct.productCounts[`${id}`] == 0) {
                let option = findOption(title, id);
                if (option) option.Selected = false;
            }

            e.preventDefault();
        }

        function addProductQueryOptions() {
            $http.post(`${apiRootUrl}v1/cart/new-purchase-options`, JSON.stringify(vm.addProduct.selections))
                .then(response => {
                    let data = response.data;
                    vm.addProduct.state = data;
                    for (let i = 0; i < data.Sections.length; i++) {
                        data.Sections[i].DefaultTitle = data.Sections[i].Title;
                    }
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function addProductUpdateOption(key, val) {
            vm.addProduct.selections[key] = val;
            vm.addProductQueryOptions();
        }

        function addProductToCart() {
            vm.addProduct.selections.CartId = vm.cartGuid;
            let data = vm.addProduct.selections;
            data.AlaCarteItems = [];
            for (let key in vm.addProduct.productCounts) {
                data.AlaCarteItems.push({Id: key, Count: vm.addProduct.productCounts[key]});
            }

            $http.post(`${apiRootUrl}v1/cart/new-purchase-add`, JSON.stringify(data))
                .then(response => {
                    let data2 = response.data;
                    vm.cartGuid = data2.CartId;
                    SessionStorageWithFallback.set('smartertoolsCartGuid', vm.cartGuid);
                    $location.path('/');
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function addInstallationOffer() {
            vm.addProduct.selections.CartId = vm.cartGuid;
            let data = vm.addProduct.selections;
            data.AlaCarteItems = [];
            for (let key in vm.addProduct.productCounts) {
                data.AlaCarteItems.push({Id: key, Count: vm.addProduct.productCounts[key]});
            }

            SessionStorageWithFallback.set('smartertoolsPreCart', JSON.stringify(data));

            $location.path('/installation-offer');
            $scope.$applyAsync();
        }

        function getCartContents() {
            if ($routeParams.product === 'support' && vm.cartGuid) {
                $http.post(`${apiRootUrl}v1/cart/contents`, JSON.stringify({CartId: vm.cartGuid}))
                    .then(response => {
                        let data = response.data;
                        if (data.Items && data.Items.length) {
                            vm.cartContents = data.Items;
                        }
                    }, () => {
                    });
            }
        }

        function toggleSupportOption(e, title, id, cost) {
            if (e.isDefaultPrevented())
                return;

            vm.addProduct.state = vm.addProduct.state || {};

            let option = findOption(title, id);
            if (!option) return;

            vm.isInCart = {};

            if (!option.selected && vm.cartContents && vm.cartContents.length) {
                for (let i = 0; i < vm.cartContents.length; i++) {
                    if (id == vm.cartContents[i].ProductId) {
                        vm.isInCart[option.Name] = {item: option.Name};

                        $scope.$applyAsync();
                        return;
                    }
                }
            }

            if (!option.Selected) {
                option.Selected = true;
                vm.addProduct.productCounts[`${id}`] = 1;
                vm.addProduct.alaCarteCost += cost;
            } else {
                option.Selected = false;
                vm.addProduct.alaCarteCost -= (cost * vm.addProduct.productCounts[`${id}`]);
                vm.addProduct.productCounts[`${id}`] = 0;
            }

            vm.addProduct.state.EnableFinishButton = vm.addProduct.alaCarteCost;

            $scope.$applyAsync();
        }

        function findOption(title, id) {
            let sections = vm.addProduct.state.Sections;
            let section;
            for (let i = 0; i < sections.length; i++) {
                if (sections[i].Title === title) {
                    section = sections[i];
                    break;
                }
            }
            if (!section) return null;

            let option;
            for (let j = 0; j < section.Options.length; j++) {
                if (section.Options[j].Value && section.Options[j].Value == id) {
                    option = section.Options[j];
                    break;
                }
            }
            return option;
        }

        function getBack() {
            let stg = sessionStorage.getItem('addProduct_back');
            vm.addProduct.back = stg
                ? JSON.parse(stg)
                : {display: 'Select Product', url: '/purchase/select-product'};
            sessionStorage.removeItem('addProduct_back');
        }
    }

})();